<template>
	<v-card flat>
		<v-card-text>
			<h3 class="mb-3 d-sm-none">Сводка</h3>
			<v-divider class="d-sm-none" />
			<card-row title="Статус">
				<v-menu
					v-if="allowedStates.length"
					offset-y
				>
					<template #activator="{ on }">
						<v-chip
							:color="order.state.color"
							small
							outlined
							label
							v-on="on"
						>
							{{ order.state.display_name }}
						</v-chip>
					</template>

					<v-list>
						<v-list-item
							v-for="state in allowedStates"
							:key="state.name"
							dense
							@click="setState(state)"
						>
							<v-list-item-title>
								<v-icon small>mdi-arrow-right</v-icon>
								{{ state.display_name }}
							</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
				<v-chip
					v-else
					:color="order.state.color"
					small
					outlined
					label
				>
					{{ order.state.display_name }}
				</v-chip>
			</card-row>
			<card-row title="Механик">
				<v-menu offset-y>
					<template #activator="{ on }">
						<v-chip
							small
							outlined
							label
							v-on="on"
						>
							{{ order.mechanic === null ? 'Не назначен' : order.mechanic.name }}
						</v-chip>
					</template>

					<v-list v-if="allowedMechanics.length">
						<v-list-item
							v-for="mechanic in allowedMechanics"
							:key="mechanic.id"
							dense
							@click="setMechanic(mechanic)"
						>
							<v-list-item-title>
								{{ mechanic.name }}
							</v-list-item-title>
						</v-list-item>
					</v-list>
					<v-alert
						v-else
						border="left"
						type="warning"
						colored-border
						class="mb-0"
					>
						Нет доступных механиков
					</v-alert>
				</v-menu>
			</card-row>
			<card-row title="Стоимость нормо-часа">{{ order.rate_per_hour }}</card-row>
			<card-row title="Суммарное время">{{ order.summary.hours }}</card-row>
			<card-row title="Стоимость работ">{{ order.summary.price.works }}</card-row>
			<card-row title="Стоимость запчастей">{{order.summary.price.parts }}</card-row>
			<card-row title="Сумма">{{ order.summary.price.total }}</card-row>

			<v-divider class="my-3" />
			<v-btn
				href="https://online.moysklad.ru/app/#invoiceout/edit?new"
				target="_blank"
				class="mr-2"
				text
				outlined
			>
				Создать счет
			</v-btn>
			<v-btn
				:loading="loadingAct"
				class="mr-2"
				text
				outlined
				@click="viewAct"
			>
				Сформировать акт
			</v-btn>
			<v-divider class="my-3" />
			<h4>Файлы</h4>
			<v-row>
				<v-col
					v-for="file in order.media"
					:key="`media-${file.id}`"
					cols="12"
					class="py-1"
				>
					<v-sheet
						class="pa-2"
						outlined
					>
						<div class="d-flex">
							<span>{{ file.custom_properties.description }}</span>
							<v-spacer />
							<v-btn
								icon
								x-small
								@click="deleteMedia(file)"
							>
								<v-icon small>mdi-close</v-icon>
							</v-btn>
						</div>
						<a :href="file.url" target="_blank">{{ file.file_name }}</a>
					</v-sheet>
				</v-col>
				<v-col cols="12" md="6">
					<repair-order-media-create-modal
						:order="order.id"
						@created="pushMedia"
					/>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import CardRow from '@/components/base/card-row';
import { PdfViewer } from '@/utils/pdf-viewer';
import RepairOrderMediaCreateModal from '@/components/orders/repair/media/create-modal';

export default {
	name: 'RepairOrderShowSummary',
	components: { RepairOrderMediaCreateModal, CardRow },
	props: {
		order: {
			type: Object,
			required: true,
		},
		allowedStates: {
			type: Array,
			required: true,
		},
	},
	data: () => ({
		allowedMechanics: [],
		loadingAct: false,
	}),
	async mounted() {
		await this.fetchMechanics();
	},
	methods: {
		async viewAct() {
			if (this.loadingAct) return;
			this.loadingAct = true;
			try {
				const response = await this.$http.get(`/api/v2/service/orders/repair/${this.order.id}/documents/act`, {
					responseType: 'arraybuffer',
				});

				const pdfViewer = new PdfViewer([response.data]);
				pdfViewer.execute();
			} catch (e) {
				this.$notify.error(e.message);
			} finally {
				this.loadingAct = false;
			}
		},
		async fetchMechanics() {
			const response = await this.$http.get('/api/v2/users', {
				params: {
					limit: 50,
					filter: {
						role: [ 'mechanic', 'mechanics-chief' ],
					},
				},
			});
			let mechanics = response.data.data;
			// todo ?. syntax
			if (!!this.order.mechanic) {
				mechanics = mechanics.filter(user => user.id !== this.order.mechanic.id);
			}
			this.allowedMechanics = mechanics;
		},
		setState(state) {
			this.$emit('set:state', state);
		},
		setMechanic(mechanic) {
			this.$emit('set:mechanic', mechanic);
		},
		pushMedia(media) {
			this.$emit('created:media', media);
		},
		async deleteMedia(media) {
			try {
				await this.$http.delete(`/api/v2/media/${media.id}`);
				this.$notify('Файл удален');
				this.$emit('deleted:media', media);
			} catch (e) {
				this.$notify.error('Ошибка удаления файла');
			}
		},
	},
};
</script>

<style scoped>

</style>
